module.exports = __webpack_public_path__ + "static/media/esim_graph3_ch.f645fc1b.png";